import React from 'react'
import { connect } from 'react-redux'

import _ from 'lodash'

import { Paper } from '@material-ui/core'
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles'
import { getStore } from "./store";


const styles = (theme: Theme) => createStyles({
  root: {
    margin: theme.spacing.unit * 3,
    maxHeight: '93%',
    overflowX: 'auto',
  },
})

interface IThemeProps extends WithStyles<typeof styles> {
  theme: Theme
}

type IAllProps = IThemeProps

// tslint:disable-next-line
class About extends React.Component<IAllProps> {

  public render() {
    const { classes } = this.props

    // try to get the file
    const store = getStore();
    const files = store.getState().files.filter(file => file.name === "events")
    var html = "NO EVENTS FILE FOUND, 5.5 and above ONLY"

    if (files.length > 0) {
      html = files[0].content
    }

    // Using dangerouslySetInnerHTML should be paired with something like
    // DOMPurify, however that requires updating of SLAB's packages
    // including typescript version and @types/node.
    // Tested upgrading TS to 4.5.4 latest and @types/node to 17.0.2 latest 
    // and it causes all sorts of breaking changes.
    return (
      <Paper className={classes.root}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Paper>
    )
  }
}

export default connect()(withStyles(styles, { withTheme: true })(About))



// WEBPACK FOOTER //
// ./src/Events.tsx